import axiosInstance from '../utils/axios';

const stockTransferService = {
  // Get all products for a specific location
  getLocationProducts: async (locationId) => {
    try {
      const response = await axiosInstance.get(`/stock-transfer/location/${locationId}/products`);
      return response.data;
    } catch (error) {
      console.error('Error fetching location products:', error);
      throw error;
    }
  },

  // Get paginated products for a specific location
  getPaginatedLocationProducts: async (locationId, page = 0, size = 10, sort = 'product.name', direction = 'ASC') => {
    try {
      const response = await axiosInstance.get(`/stock-transfer/location/${locationId}/products/paged`, {
        params: { page, size, sort, direction }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching paginated location products:', error);
      throw error;
    }
  },

  // Get products for a specific location filtered by category
  getLocationProductsByCategory: async (locationId, categoryId) => {
    try {
      const response = await axiosInstance.get(`/stock-transfer/location/${locationId}/products/category/${categoryId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching location products by category:', error);
      throw error;
    }
  },

  // Transfer stock from warehouse to location
  transferStock: async (transferData) => {
    try {
      const response = await axiosInstance.post(`/stock-transfer/transfer`, transferData);
      return response.data;
    } catch (error) {
      console.error('Error transferring stock:', error);
      throw error;
    }
  },

  // Get stock transfer history for a location
  getTransferHistory: async (locationId) => {
    try {
      const response = await axiosInstance.get(`/stock-transfer/history/${locationId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching transfer history:', error);
      throw error;
    }
  },

  // Get paginated stock transfer history for a location
  getPaginatedTransferHistory: async (locationId, page = 0, size = 10, sort = 'transactionDate', direction = 'DESC') => {
    try {
      const response = await axiosInstance.get(`/stock-transfer/history/${locationId}/paged`, {
        params: { page, size, sort, direction }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching paginated transfer history:', error);
      throw error;
    }
  },

  // Get all stock transfers
  getAllTransfers: async () => {
    try {
      const response = await axiosInstance.get(`/stock-transfer/all`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all transfers:', error);
      throw error;
    }
  },

  // Get all stock transfers with pagination and search
  getPaginatedTransfers: async (page = 0, size = 10, sort = 'transactionDate', direction = 'DESC', search = null) => {
    try {
      const params = { page, size, sort, direction };
      if (search) {
        params.search = search;
      }
      const response = await axiosInstance.get(`/stock-transfer/all/paged`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching paginated transfers:', error);
      throw error;
    }
  },

  // Get transfer by ID
  getTransferById: async (id) => {
    try {
      const response = await axiosInstance.get(`/stock-transfer/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching transfer by ID:', error);
      throw error;
    }
  },

  // Cancel a transfer
  cancelTransfer: async (id) => {
    try {
      const response = await axiosInstance.post(`/stock-transfer/${id}/cancel`);
      return response.data;
    } catch (error) {
      console.error('Error cancelling transfer:', error);
      throw error;
    }
  },

  // Delete a transfer
  deleteTransfer: async (id) => {
    try {
      const response = await axiosInstance.delete(`/stock-transfer/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting transfer:', error);
      throw error;
    }
  }
};

export default stockTransferService;
